import { render, staticRenderFns } from "./AsideMyScoreSection.vue?vue&type=template&id=4040cca0&"
import script from "./AsideMyScoreSection.vue?vue&type=script&lang=js&"
export * from "./AsideMyScoreSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports